import { Component } from "@angular/core";
import { AuthService } from "@ponder-core/auth/auth.service";
import { AdminUnauthorizedComponent } from "../admin-unauthorized.component";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { UserPermissionType } from "@apiserver-rest/ponder-auth-client-base";
import { RoleAndPermissions } from "@ponder-core/auth/role-permissions";
import { PonderTasksClient } from "@apiserver-rest/ponder-tasks-client";
import { take } from "rxjs";
import { DescribeTasksResponse, GetRecentTasksResponse, TaskDescription, TaskSummary } from "@apiserver-rest/ponder-tasks-client-base";
import { NgClass } from "@angular/common";
import { TaskSummaryRowComponent } from "./task-summary-row.component";
import { TaskDisplayComponent } from "./task-display.component";
import { TaskViewComponent } from "./task-view.component";
import { ActivatedRoute } from "@angular/router";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "admin-tasks",
    imports: [NgClass, LoadingComponent, AdminUnauthorizedComponent, TaskSummaryRowComponent, TaskDisplayComponent, TaskViewComponent],
    templateUrl: "./admin-tasks.component.html"
})
export class AdminTasksComponent {
    public canView: boolean = false;
    public canEdit: boolean = false;

    public loadingTasks: boolean = true;
    public loadingTasksSuccess: boolean = false;
    public taskDescriptions?: TaskDescription[];
    public selectedTask?: TaskDescription;

    public loadingTaskSummaries: boolean = true;
    public loadingTaskSummariesSuccess: boolean = false;
    public taskSummaries?: TaskSummary[];

    public constructor(
        private authService: AuthService, 
        private ponderTasksClient: PonderTasksClient, 
        private route: ActivatedRoute,
        private events: EventBroker) {
        
    }

    public ngOnDestroy(): void {
        
    }

    public ngOnInit(): void {
        var queryParams = this.route.snapshot.queryParamMap;

        if (queryParams.has("task")) {
            this.events.admin.viewTaskEvent.emit(queryParams.get("task")!);
        }

        this.authService.getRoleAndPermissions().then((roleAndPermissions: RoleAndPermissions | undefined) => {
            this.canView = roleAndPermissions?.hasPermission(UserPermissionType.ViewTasks) == true;
            this.canEdit = roleAndPermissions?.hasPermission(UserPermissionType.RunTasks) == true;

            if (this.canView) {
                this.fetchData();
            }
        });
    }

    private fetchData(): void {
        this.fetchTaskDescriptions();
        this.fetchTaskSummaries();
    }

    private fetchTaskDescriptions(): void {
        this.ponderTasksClient
            .tasksDescribe()
            .pipe(take(1))
            .subscribe({
                next: (response: DescribeTasksResponse) => {
                    if (response.success && response.tasks) {
                        this.taskDescriptions = response.tasks;
                        this.taskDescriptions.sort((a, b) => a.taskName.localeCompare(b.taskName));

                        this.loadingTasksSuccess = true;
                    }
                }
            })
            .add(() => { this.loadingTasks = false; })
    }

    private fetchTaskSummaries(): void {
        this.ponderTasksClient
            .tasksSummary()
            .pipe(take(1))
            .subscribe({
                next: (response: GetRecentTasksResponse) => {
                    if (response.success && response.taskSummaries) {
                        this.taskSummaries = response.taskSummaries;
                        this.loadingTaskSummariesSuccess = true;
                    }
                }
            })
            .add(() => { this.loadingTaskSummaries = false; })
    }
    
    public onTaskRowClicked(taskDescription: TaskDescription): void {
        this.selectedTask = taskDescription;
    }
}